module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "level-form"
    }
  }, [_vm._l((_vm.kelasList), function(kelasItem) {
    return _c('v-card', {
      key: kelasItem.kelas,
      staticClass: "mb-5",
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-actions', [_c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("Kelas")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "value": kelasItem.kelas,
        "outlined": "",
        "disabled": "",
        "filled": ""
      }
    })], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          kelasItem.show = !kelasItem.show
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(kelasItem.show ? "mdi-chevron-up" : "mdi-chevron-down"))])], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (kelasItem.show),
        expression: "kelasItem.show"
      }],
      staticClass: "mx-5"
    }, [_c('v-divider'), _vm._v(" "), _vm._l((kelasItem.levels), function(level, levelIndex) {
      return _c('div', {
        key: levelIndex,
        staticClass: "mt-5"
      }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
        staticClass: "font-weight-bold pb-2"
      }, [_vm._v("Level")]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "value": level.value,
          "outlined": "",
          "disabled": "",
          "filled": ""
        }
      })], 1)], 1), _vm._v(" "), _c('v-row', {
        attrs: {
          "dense": ""
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "6"
        }
      }, [_c('v-text-field', {
        attrs: {
          "type": "number",
          "label": "Minimal Poin",
          "outlined": ""
        },
        model: {
          value: (level.min_poin),
          callback: function($$v) {
            _vm.$set(level, "min_poin", $$v)
          },
          expression: "level.min_poin"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "6"
        }
      }, [_c('v-text-field', {
        attrs: {
          "type": "number",
          "label": "Maksimal Poin",
          "outlined": "",
          "disabled": level.value === 'Gold'
        },
        model: {
          value: (level.max_poin),
          callback: function($$v) {
            _vm.$set(level, "max_poin", $$v)
          },
          expression: "level.max_poin"
        }
      })], 1)], 1), _vm._v(" "), (levelIndex < kelasItem.levels.length - 1) ? _c('v-divider') : _vm._e()], 1)
    }), _vm._v(" "), _c('v-card-actions', {
      staticClass: "mb-2"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.submitLevel(kelasItem.kelas, kelasItem.levels)
        }
      }
    }, [_vm._v("\n                        Simpan Level Kelas " + _vm._s(kelasItem.kelas) + "\n                    ")])], 1)], 2)])], 1)
  }), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-351f4890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/LevelEditForm.vue
// module id = 971
// module chunks = 1